import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import '../../assets/css/common.css';
import Header from './Header';
import Sidebar from './Sidebar';

const adminItems = [
  { to: "/system/alert-dashboard", label: "알림 채널 대시보드" },
  { to: "/system/channel-settings", label: "채널 설정 관리" },
  { to: "/system/admin-accounts", label: "관리자 계정 관리" },
  { to: "/system/medical-staff", label: "의료진 관리" },
  { to: "/system/sessions", label: "세션 관리" },
  { to: "/system/security", label: "계정 보안 관리" },
  { to: "/system/password-policy", label: "비밀번호 정책 관리" },
  { to: "/system/calibration-policy", label: "보정 정책 설정" },
  { to: "/system/system-alerts", label: "시스템 알림 관리" },
  { to: "/system/mobile-code-policies", label: "모바일 코드 정책 관리" },
  { to: "/system/monitoring", label: "시스템 무결성 모니터링" },
  { to: "/system/audit-logs", label: "감사로그 모니터링" },
  { to: "/system/audit-capacity", label: "감사로그 용량 모니터링" },
];

const AdminLayout = () => {
  return (
    <div className="wrap">
      <Header />
      <div className="section_area">
        <Sidebar items={adminItems} />
        <div className="section_wrap">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
